import { useTranslation } from 'react-i18next'

import { Card, CardTitle, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TransactionSummaryCardSkeleton = () => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Desglose transacción')}</CardTitle>
      <Styles.Container>
        <Styles.SummaryContainer>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="50%" height={16} />
          <Skeleton variant="rounded" width="55%" height={16} />
        </Styles.SummaryContainer>

        <Skeleton variant="rounded" width="100%" height={24} />

        <Skeleton variant="rounded" width="100%" height={24} />
      </Styles.Container>
    </Card>
  )
}

export default TransactionSummaryCardSkeleton
